import { GetterTree } from 'vuex';

import {
  ServicesStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<ServicesStateI, RootStateI> = {
};
